import { apiClient, handleResp } from './utils';
export default {
  getMessages() {
    return handleResp(apiClient().get('/messages'));
  },
  getMessageInfo(messageId) {
    return handleResp(apiClient().get('/messages/' + messageId));
  },
  getSubscriptionDetails() {
    return handleResp(apiClient().get('/subscription_details'));
  },
  getConnectRequests(accountId) {
    return handleResp(apiClient().get('/get_church_connections?account_id=' + accountId));
  },
  getReviewConnectRequests(accountId) {
    return handleResp(apiClient().get('/get_review_church_connections?account_id=' + accountId));
  },
  getChurchModerators(accountId) {
    return handleResp(apiClient().get('/church_moderators?account_id=' + accountId));
  },
  doUpdateProfile(dataInput) {
    return handleResp(apiClient().post('/edit_profile', dataInput));
  },
  doCreateUser(dataInput) {
    return handleResp(apiClient().post('/care_user', dataInput));
  },
  doGetUserInfo() {
    return handleResp(apiClient().post('/lookup_profile'));
  },
  doGetUserInfo1() {
    return handleResp(apiClient().post('/lookup_user'));
  },
  doUpdateChurchProfile(dataInput) {
    return handleResp(apiClient().post('/edit_care', dataInput));
  },
  doUpgradeMembership(dataInput) {
    return handleResp(apiClient().post('/users/upgrade_membership', dataInput));
  },
  doGetChurchProfile(isHandleError = false) {
    return handleResp(apiClient().post('/lookup_profile'), isHandleError);
  },
  // eslint-disable-next-line camelcase
  doUpdateBillingInfo(recurly_token) {
    return handleResp(apiClient().post('/creditcard_reset', { recurly_token }));
  },
  doUpdateShippingInfo(dataInput) {
    return handleResp(apiClient().post('/users/update_shipping', dataInput));
  },
  doUpdateUser(dataInput) {
    return handleResp(apiClient().post('/update_user', dataInput));
  },
  doAcceptChurchInvitation(dataInput) {
    return handleResp(apiClient().post('/accept_church_invite', dataInput));
  },
  doDisconnectChurchConnect(dataInput) {
    return handleResp(apiClient().post('/destroy_church_connection', dataInput));
  },
  doRequestChurchCreation(dataInput) {
    return handleResp(apiClient().post('/create_church_connection', dataInput));
  },
  doSendNewEmailToken(dataInput) {
    return handleResp(apiClient().post('/send_new_email_token', dataInput));
  },
  doVerifyNewEmail(dataInput) {
    return handleResp(apiClient().post('/verify_new_email', dataInput));
  },
  updateActionStep(data) {
    return handleResp(apiClient().post('/update_action_step', data));
  },
};
